import mountReactApp from 'src/utils/mountReactApp'
import App from 'src/widgets/goal/App'

mountReactApp(App)
